import type { updateFeedbackBodyZod } from "@nlc/shared-types";
import type * as z from "zod";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { feedbackToolKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export type UpdateFeedbackFormData = z.infer<typeof updateFeedbackBodyZod>;

export function useUpdateFeedback(
  storyId: number | undefined,
  parentId: number,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateFeedbackFormData) =>
      apiClient.url(`/stories/feedback-tool/${storyId}`).patch(data).json(),
    mutationKey: feedbackToolKeys.update(storyId),
    onError: (err) => {
      console.error("error", err);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: feedbackToolKeys.feedbacks(parentId),
      });
    },
  });
}
